import { Blog } from '@/commonTypes';
import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { useLocale, useTranslations } from 'next-intl';
import config from '@/api/global';
import MainIcons from '@/icons/main';

export default function BlogShare({ data }: { data?: Blog }) {
  const locale = useLocale();
  const tCommon = useTranslations('common');
  const [showCopied, setShowCopied] = useState(false);

  let siteUrl = `${process.env.copy_URL}${locale == config.defaultLocale ? '' : '/' + locale}/blog/${data?.slug}`;
  const copyLink = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    navigator.clipboard.writeText(`${siteUrl}`);
    setShowCopied(true);
  };

  const buttons = [
    {
      label: 'تلگرام',
      icon: <MainIcons.telegramIcon fill="var(--telegram-color)" width="16px" height="16px" />,
      className: styles.telegram,
      href: `https://t.me/share/url?url=${encodeURIComponent(siteUrl)}`,
      iconSize: 16,
    },
    {
      label: 'ایکس',
      // icon: <MainIcons.twitterIcon fill="var(--x-color)" width="16px" height="16px" />,
      icon: '𝕏',
      className: styles.x,
      href: `https://twitter.com/intent/tweet?url=${encodeURIComponent(siteUrl)}`,
      iconSize: 14,
    },
    {
      label: 'واتساپ',
      icon: <MainIcons.whatsappIcon fill="var(--whatsapp-color)" width="16px" height="16px" />,
      className: styles.whatsapp,
      href: `https://wa.me/?text=${encodeURIComponent(siteUrl)}`,
      iconSize: 16,
    },
    {
      label: 'کپی لینک',
      icon: (
        <>
          ⎘
          <span className={`${showCopied ? `${styles.showCopy}` : `${styles.hideCopy}`}`}>
            کپی شد
          </span>
        </>
      ),
      className: styles.copy,
      onClick: copyLink,
      iconSize: 15,
    },
  ];
  useEffect(() => {
    if (showCopied) {
      const timer = setTimeout(() => {
        setShowCopied(false);
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [showCopied]);
  return (
    <div className={styles.container}>
      {/* <p className={`${styles.blogTitle}`}>{data?.title}</p>
      <p className={`${styles.excerpt}`}>{data?.excerpt}</p> */}
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <MainIcons.send fill="var(--brand-deep)" />
          <span>این مقاله را به اشتراک بگذارید</span>
        </div>

        <div className={styles.actions}>
          {buttons.map(({ label, icon, className, href, onClick, iconSize }) =>
            href ? (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className={`${styles.button} ${className}`}
              >
                {/* <svg width={iconSize} height={iconSize}>
                <use href={icon} />
              </svg> */}
                {icon}
                <span>{label}</span>
              </a>
            ) : (
              <div key={label} onClick={onClick} className={`${styles.button} ${className}`}>
                {icon}
                <span>{label}</span>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
}
